<template>
    <z-basePage :title="title" :pop="true">
        <z-backForm :name="'back-currency'" :align="true" @save="saveSet" @cancel="backset">
            <!-- 快币类型 -->
            <!-- <div class="back-item">
                <div class="back-title">适用对象</div>
                <div class="back-wrap text">
                    {{ type==10?"任务快币":"任务罚币" }}
                </div>
            </div> -->
            <!-- 快币名称 -->
            <div class="back-item">
                <div class="back-title">快币名称</div>
                <div class="back-wrap text">
                    <div v-if="type == 20">{{ sub.name }}</div>
                    <el-input v-else class="top-choose" rule="limit" v-arg="[0,5]" v-tar="sub.name" v-model="sub.name" placeholder="请输入快币名称"></el-input>
                </div>
            </div>
            <!-- 快币描述 -->
            <div class="back-item area">
                <div class="back-title">快币描述</div>
                <div class="back-wrap">
                    <textarea rule="reason describe_limit" v-arg="'快币描述'" v-tar="sub.describe" v-model="sub.describe" placeholder="请输入快币描述"></textarea>
                </div>
            </div>


        </z-backForm>

    </z-basePage>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        data(){
            return {
                // screen_loading:false,
                type:10,  //快币类型

                sub:{
                    name:"",
                    describe:"",
                },
            }
        },
        computed:{
            currencyId(){  //快币id
                return parseInt(this.$crypto.decrypt(this.$route.params.id));
            },
            title(){
                return this.currencyId?"编辑快币":'创建快币';
            },
        },
        created(){
            if(this.currencyId){
                let data = this.$func.queryCurrency(this.currencyId);
                this.type = data.currency_type;
                this.sub.name = data.currency_name;
                this.sub.describe = data.description;
                this.$form.init('back-currency');
            }
        },
        beforeRouteLeave(to,from,next){  //离开页面之前
			let res = this.$form.leave({name:'back-currency',path:to.path});
			next(res);
		},
        methods:{
            saveSet(){
                let k_id = this.currencyId;
                let obj = {
                    currency_name:this.sub.name,
                    description:this.sub.describe,
                    currency_type:this.type,
                }

                this.$func.loading(true);

                if(k_id){  //编辑快币
                    let url = `api/admin/currency/${k_id}`;
                    this.$http.put(url,obj).then(res=>{
                        if(res.status == 200){
                            // this.$func.getCurrencyList(true);  //拉取新的快币类型列表
                            this.$router.go(-1);
                            this.successTip("保存成功");
                        }
                        this.$func.loading(false);
                    });
                }else{  //创建快币
                    let url = `api/admin/currency`;
                    this.$http.post(url,obj).then(res=>{
                        if(res.status == 200){
                            // this.$func.getCurrencyList(true);  //拉取新的快币类型列表
                            this.$router.go(-1);
                            this.successTip("创建成功");
                        }
                        this.$func.loading(false);
                    });
                }
            },
            backset(dataArr){
                [
                    this.sub.name,
                    this.sub.describe,
                ] = dataArr;
            }

        },
    }
</script>

<style lang="less">

</style>





// WEBPACK FOOTER //
// page-currencyAdd.vue?4b6d43e8